"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatActions = exports.ChatDeepLinks = exports.AgentType = exports.ChatDeflection = exports.ChatQuality = exports.ChatStatus = void 0;
var ChatStatus;
(function (ChatStatus) {
    ChatStatus["ACTIVE"] = "ACTIVE";
    ChatStatus["CLOSED"] = "CLOSED";
})(ChatStatus || (exports.ChatStatus = ChatStatus = {}));
var ChatQuality;
(function (ChatQuality) {
    ChatQuality["HIGH"] = "HIGH";
    ChatQuality["MEDIUM"] = "MEDIUM";
    ChatQuality["UNMARKED"] = "UNMARKED";
    ChatQuality["LOW"] = "LOW";
    ChatQuality["DEAD_END"] = "DEAD_END";
})(ChatQuality || (exports.ChatQuality = ChatQuality = {}));
var ChatDeflection;
(function (ChatDeflection) {
    ChatDeflection["DEFLECTED"] = "DEFLECTED";
    ChatDeflection["NOT_DEFLECTED"] = "NOT_DEFLECTED";
})(ChatDeflection || (exports.ChatDeflection = ChatDeflection = {}));
var AgentType;
(function (AgentType) {
    AgentType["BOT"] = "BOT";
    AgentType["AGENT"] = "AGENT";
})(AgentType || (exports.AgentType = AgentType = {}));
var ChatDeepLinks;
(function (ChatDeepLinks) {
    ChatDeepLinks["LIST_ORDERS"] = "list-orders";
    ChatDeepLinks["NONE"] = "none";
})(ChatDeepLinks || (exports.ChatDeepLinks = ChatDeepLinks = {}));
var ChatActions;
(function (ChatActions) {
    ChatActions["AIRPORT_TRANSFERS_PURCHASE"] = "airportTransfersPurchase";
    ChatActions["AIRPORT_TRANSFERS_BOOK"] = "airportTransfersBook";
    ChatActions["AIRPORT_TRANSFERS_ACTIONS"] = "airportTransfersActions";
    ChatActions["AIRPORT_TRANSFERS_UPSELL"] = "airportTransfersUpsell";
    ChatActions["AIRPORT_TRANSFERS_SELECT_ORDER"] = "airportTransfersSelectOrder";
    ChatActions["AIRPORT_TRANSFERS_EMPTY"] = "airportTransfersEmpty";
    ChatActions["AIRPORT_TRANSFERS_MISSING"] = "airportTransfersMissing";
    ChatActions["AIRPORT_TRANSFERS_FORM"] = "airportTransfersForm";
    ChatActions["ADD_EXTRA_GUESTS"] = "addExtraGuests";
    ChatActions["CANCEL_ORDER"] = "cancelOrder";
    ChatActions["CAR_HIRE_UPSELL"] = "carHireUpsell";
    ChatActions["CHANGE_DATES"] = "changeDates";
    ChatActions["CHANGE_ROOM"] = "changeRoom";
    ChatActions["CONFIRM_REQUEST_AGENT"] = "confirmRequestAgent";
    ChatActions["CONFIRM_RESEND_CONFIRMATION_EMAIL"] = "confirmResendConfirmationEmail";
    ChatActions["CRUISES_ACTIONS"] = "cruisesActions";
    ChatActions["DOWNLOAD_TAX_INVOICE"] = "downloadTaxInvoice";
    ChatActions["DUPLICATE_ACTION_REQUEST_AGENT"] = "duplicateActionRequestAgent";
    ChatActions["FLIGHTS_ELECTRONIC_TICKETS_REQUEST"] = "flightsElectronicTicketsRequest";
    ChatActions["GOTO_ACCOUNT_DETAILS"] = "gotoAccountDetails";
    ChatActions["GOTO_EMAIL_CHANGE"] = "gotoEmailChange";
    ChatActions["GOTO_PHONE_CHANGE"] = "gotoPhoneChange";
    ChatActions["LIST_DEFAULT_ACTIONS"] = "listDefaultActions";
    ChatActions["LIST_FAQ"] = "listFAQ";
    ChatActions["LIST_FLIGHT_ORDERS"] = "listFlightOrders";
    ChatActions["LIST_INCLUSIONS"] = "listInclusions";
    ChatActions["LIST_ORDER_ACTIONS"] = "listOrderActions";
    ChatActions["LIST_ORDER_ITEMS"] = "listOrderItems";
    ChatActions["LIST_ORDERS"] = "listOrders";
    ChatActions["LIST_ORDERS_EXTRA_GUESTS"] = "listOrdersExtraGuests";
    ChatActions["LIST_ORDER_ITEMS_EXTRA_GUESTS"] = "listOrderItemsExtraGuests";
    ChatActions["LOGIN"] = "login";
    ChatActions["LOGIN_CANCELLED_WHEN_REQUESTING_CALLBACK"] = "loginCancelledWhenRequestingCallback";
    ChatActions["LOGIN_ISSUE"] = "loginIssue";
    ChatActions["LOGIN_WITH_DEFAULT_ACTIONS"] = "loginWithDefaultActions";
    ChatActions["LOGIN_WITH_BOOKING_ID"] = "loginWithBookingID";
    ChatActions["MANAGE_ACCOUNT_DETAILS"] = "manageAccountDetails";
    ChatActions["MANAGE_BOOKING"] = "manageBooking";
    ChatActions["MANAGE_BOOKING_BY_ID"] = "manageBookingByID";
    ChatActions["ORDER_ADD_DATES"] = "orderAddDates";
    ChatActions["OTP_LOGIN"] = "otpLogin";
    ChatActions["OTP_LOGIN_WITHOUT_EMAIL"] = "otpLoginWithoutEmail";
    ChatActions["PAYMENT_DIFFICULTY_ASSISTANCE"] = "paymentDifficultyAssistance";
    ChatActions["PRE_SELECT_ORDER"] = "preSelectOrder";
    ChatActions["PAYMENT_ISSUES_CONFIRM_REQUEST_AGENT"] = "paymentIssuesConfirmRequestAgent";
    ChatActions["REQUEST_AGENT"] = "requestAgent";
    ChatActions["REQUEST_AGENT_ANONYMOUS"] = "requestAgentAnonymous";
    ChatActions["REQUEST_AGENT_CALLBACK"] = "requestAgentCallback";
    ChatActions["REQUEST_AGENT_CALLBACK_ERROR"] = "requestAgentCallbackError";
    ChatActions["REQUEST_AGENT_CALLBACK_CANCEL"] = "requestAgentCallbackCancel";
    ChatActions["REQUEST_AGENT_CALLBACK_IMMEDIATE"] = "As soon as possible";
    ChatActions["RESEND_CONFIRMATION_EMAIL"] = "resendConfirmationEmail";
    ChatActions["RESET_OR_OTP_LOGIN_OPTIONS"] = "resetOrOtpLoginOptions";
    ChatActions["RESET_PASSWORD_CONFIRMATION"] = "resetPasswordConfirmation";
    ChatActions["RESET_PASSWORD_REQUEST_EMAIL"] = "resetPasswordRequestEmail";
    ChatActions["RESET_PASSWORD_SENT"] = "resetPasswordSent";
    ChatActions["SALES_ACTIONS"] = "salesActions";
    ChatActions["HOTELS_ACTIONS"] = "hotelsActions";
    ChatActions["HELP_WITH_A_NEW_BOOKING_ACTIONS"] = "helpWithANewBookingActions";
    ChatActions["TOURS_ACTIONS"] = "toursActions";
    ChatActions["SEARCH_ARTICLE"] = "searchArticle";
    ChatActions["SELECT_ORDER"] = "selectOrder";
    ChatActions["SELECT_FLIGHT_ORDER"] = "selectFlightOrder";
    ChatActions["SELECT_ORDER_ITEM"] = "selectOrderItem";
    ChatActions["SHOW_FINE_PRINT"] = "showFinePrint";
    ChatActions["SOMETHING_ELSE"] = "somethingElse";
    ChatActions["START_ACTIONS"] = "startActions";
    ChatActions["UNSUPPORTED_ACTION"] = "unsupportedAction";
    ChatActions["PRIORITY_ACCESS_CALL"] = "priorityAccessCall";
    ChatActions["MANAGE_CURRENT_ORDER"] = "manageCurrentOrder";
    ChatActions["INSURANCE_UPSELL"] = "insuranceUpsell";
    ChatActions["SELECT_ORDER_EXTRA_GUESTS"] = "selectOrderExtraGuests";
    ChatActions["SELECT_ORDER_ITEM_EXTRA_GUESTS"] = "selectOrderItemExtraGuests";
})(ChatActions || (exports.ChatActions = ChatActions = {}));
